import React, { useState } from "react";
import useSupportTickets from "./useSupportTickets";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import ConfirmationModal from "./ConfirmationModal";

function ListSupportTickets({ onSetActiveTab }) {
  const {
    ticketsData,
    isGettingTickets,
    errorGettingTickets,
    deleteSupportTicketFn,
    isDeletingSupportTicket,
  } = useSupportTickets();

  const [deletingId, setDeletingId] = useState(null);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    ticket: null,
  });

  if (isGettingTickets) return <CustomLoading />;
  if (errorGettingTickets)
    return <div className="text-red-500">Error loading support tickets.</div>;

  const handleDelete = (ticket) => {
    setConfirmModal({ open: true, ticket });
  };

  const confirmDelete = () => {
    const ticketId = confirmModal.ticket._id;
    setDeletingId(ticketId);
    deleteSupportTicketFn(ticketId, {
      onSettled: () => {
        setDeletingId(null);
        setConfirmModal({ open: false, ticket: null });
      },
    });
  };

  const cancelDelete = () => {
    setConfirmModal({ open: false, ticket: null });
  };

  const tickets = ticketsData?.data?.tickets ?? [];

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Support Tickets</h2>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          onClick={() => onSetActiveTab("create")}
        >
          + New Ticket
        </button>
      </div>

      <div className="grid gap-6">
        {tickets.length > 0 ? (
          [...tickets].reverse().map((ticket) => (
            <div
              key={ticket._id}
              className="bg-white rounded shadow p-6 flex flex-col md:flex-row md:items-center md:justify-between"
            >
              <div className="flex-1 space-y-2">
                <div className="flex items-center gap-4 text-lg font-semibold">
                  <span>{ticket.type}</span>
                  <span className="text-gray-500">/</span>
                  <span className="capitalize text-gray-700">
                    {ticket.impactLevel}
                  </span>
                </div>
                <div className="text-sm text-gray-700 flex flex-wrap gap-4">
                  <span>
                    <span className="font-medium">Status:</span> {ticket.status}
                  </span>
                  <span>
                    <span className="font-medium">Created by:</span>{" "}
                    {ticket.createdBy?.name}
                  </span>
                  <span>
                    <span className="font-medium">Phone:</span>{" "}
                    {ticket.createdBy?.phoneNo}
                  </span>
                  <span>
                    <span className="font-medium">Priority:</span>{" "}
                    {ticket.priority}
                  </span>
                  <span>
                    <span className="font-medium">Days Since Creation:</span>{" "}
                    {ticket.daysSinceCreation}
                  </span>
                  <span>
                    <span className="font-medium">Tags:</span>{" "}
                    {ticket.tags.length > 0 ? ticket.tags.join(", ") : "None"}
                  </span>
                  <span className="text-gray-400 text-xs">
                    Created: {new Date(ticket.createdAt).toLocaleDateString()}
                  </span>
                </div>

                <div className="text-sm text-gray-500">
                  <span className="font-medium">Details:</span> {ticket.details}
                </div>
              </div>

              <div className="flex flex-col gap-2 mt-4 md:mt-0 md:ml-6 items-end">
                <button
                  className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                  onClick={() => handleDelete(ticket)}
                  // disabled={
                  //   isDeletingSupportTicket && deletingId === ticket._id
                  // }
                >
                  Delete
                  {/* {isDeletingSupportTicket && deletingId === ticket._id
                    ? "Deleting..."
                    : "Delete"} */}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-12 text-gray-500">
            No support tickets found.
          </div>
        )}
      </div>

      {confirmModal.open && (
        <ConfirmationModal
          isDeletingSupportTicket={isDeletingSupportTicket}
          cancelDelete={cancelDelete}
          confirmDelete={confirmDelete}
          confirmModal={confirmModal}
        />
      )}
    </div>
  );
}

export default ListSupportTickets;
